import { render } from "./PeoplePaperExam.vue?vue&type=template&id=2586e5e4&scoped=true"
import script from "./PeoplePaperExam.vue?vue&type=script&lang=js"
export * from "./PeoplePaperExam.vue?vue&type=script&lang=js"

import "./PeoplePaperExam.vue?vue&type=style&index=0&id=2586e5e4&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2586e5e4"]])

export default __exports__